import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
      id: "",
      quantity: 0,
      manufacturer: "",
      model: "",
      groupId: "",
      organizationId: "",
      serialNumbers: []

  },
  assignmentData: {
    groupName: "",
    totalDevices: 0,
    deviceName: "",
    groupDeviceId: 0,
    serialNums: []
  },
  updating: false,
};

const deviceRegistrySlice = createSlice({
  name: 'deviceRegistry',
  initialState,
  reducers: {
    resetDeviceState: (state) => {
      Object.assign(state, initialState);
    },
    setUpdatingDevice(state, action) {
      state.data = action.payload;
      state.updating = true;
    },
    setAssignmentData(state, action) {
      state.assignmentData = action.payload;
    }
  },
});

export const {
    resetDeviceState,
    setUpdatingDevice,
    setAssignmentData
} = deviceRegistrySlice.actions;

export default deviceRegistrySlice.reducer;
